import React from 'react';
// import SarasDnDList from '../../../library/hooks/bdnd/SarasDnDList';
import SarasDnDList from '../../../library/hooks/dndkit/SarasDnDList';
import DocImageRow from './DocImageRow'

const DocImageRowDNDList = (props) => {
    const { formObject, viewData, rowKeys, sarasDnDManager } = props;

    const renderDnDRow = (rowId, index) => {
        let row = viewData[rowId];

        return (
            <li
                key={rowId}
                rowKey={rowId}
                className={sarasDnDManager.isSortMode() ? "uiShrinkInSort uiSpacerL5" : "uiInline uiSpacerL5"}
                style={{listStyle: 'none'}}
            >
                <DocImageRow formObject={formObject} index={index} rowKey={rowId}
                    viewData={row}
                    groupKey={1} isSortMode={sarasDnDManager.isSortMode()}
                />
            </li>
        )
    }

    return (
        <SarasDnDList groupKey={1} sarasDnDManager={sarasDnDManager} >
            {
                rowKeys && rowKeys.map((rowId, index) => (
                    renderDnDRow(rowId, index)
                ))
            }
        </SarasDnDList>
    )
}

export default DocImageRowDNDList
